import { theme, styled, utils } from 'ui/theme';
import { Container as ContainerBase } from 'ui/components/primitives';

export const Container = styled(ContainerBase)`
  &[data-margin-bottom='sp-6'] {
    margin-bottom: ${theme.space[6]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[6]};
    `}
  }

  &[data-margin-top='sp-6'] {
    margin-top: ${theme.space[6]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[6]};
    `}
  }
`;
